/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  PhoneStatusResponse,
  PhoneVerifyRequest
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * After the admin approved the app in Microsoft: connect the tenant they
 * proved at sign-in. ORG ADMINS ONLY. Takes no tenant from the request; `state`
 * is the consent state from the `consentUrl` this user was given.
 * @summary Verify Phone Consent
 */
export const verifyPhoneConsent = (
    phoneVerifyRequest: PhoneVerifyRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneStatusResponse>(
      {url: `/phone/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: phoneVerifyRequest, signal
    },
      options);
    }




export const getVerifyPhoneConsentMutationKey = () => ['verifyPhoneConsent'] as const;

export const getVerifyPhoneConsentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneConsent>>, TError,VerifyPhoneConsentMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneConsent>>, TError,VerifyPhoneConsentMutationVariables, TContext> => {

const mutationKey = getVerifyPhoneConsentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPhoneConsent>>, VerifyPhoneConsentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyPhoneConsent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyPhoneConsentMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPhoneConsent>>>
    export type VerifyPhoneConsentMutationBody = PhoneVerifyRequest
    export type VerifyPhoneConsentMutationError = HTTPValidationError
    export type VerifyPhoneConsentMutationVariables = {data: PhoneVerifyRequest}

    /**
 * @summary Verify Phone Consent
 */
export const useVerifyPhoneConsent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneConsent>>, TError,VerifyPhoneConsentMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyPhoneConsent>>,
        TError,
        VerifyPhoneConsentMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyPhoneConsentMutationOptions(options));
    }
